export const PRODUCT_SUBSTITUTION_QUESTIONS = [
  'eC3DReportOK',
  'eC2DReportOK',
  'premiumReportOK',
  'residential2CommercialOK',
  'quickSquaresToQSECOK',
  'standardReportOK',
  'accuracyWaiverOK',
  'wallsOnlyToWallsLiteOK',
  'bidPerfectToQS',
  'fullHouseToQS',
  'fullHouseToRoofOnlyOK',
  'bidPerfectCommercialToPremiumCommercial',
  'commercialToResidential',
  'roof3DToRoof2DOK',
];

export const YES = 1;
export const NO = 2;
export const ASK = 3;

export const PRODUCT_SUBSTITUTIONS_OPTIONS = {
  YES,
  NO,
  ASK,
};
